import { render, staticRenderFns } from "./FreeDownload.vue?vue&type=template&id=04d19a35&"
import script from "./FreeDownload.vue?vue&type=script&lang=js&"
export * from "./FreeDownload.vue?vue&type=script&lang=js&"
import style0 from "./FreeDownload.vue?vue&type=style&index=0&id=04d19a35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports